const origin   =        window.location.origin
const MAIN_HOST  = origin.includes("nane1-lower-gke1.lblw.cloud")?origin+"/dcn-esign-po-data":"https://dcn-esign-podata.dev.loblaw.ca";
const SUB_HOST = `${MAIN_HOST}/api/v1`;
const NCTM_HOST =  "https://nctm-esign-sit.nane1-lower-gke1.lblw.cloud/userapi/userdetails"

export const environment = {
  logouturl:"https://login.microsoftonline.com/7a1a5a29-bd1e-49dc-a770-d3f94f5d19e4/oauth2/v2.0/logout",
  oidcSettings: {
    client_id : '7a1a5a29-bd1e-49dc-a770-d3f94f5d19e4',
    authority: 'https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/v2.0/',
    response_type: 'code',
    redirect_uri:  origin+'/auth-callback',
    post_logout_redirect_uri: origin,
    scope: "openid profile user.read",
    filterProtocolClaims: true,
    loadUserInfo: false,
    sessionChecksEnabled: true,
  },
  msalSettings :
  {
    auth: {
      clientId: '7a1a5a29-bd1e-49dc-a770-d3f94f5d19e4',
      //clientId: '9b4d001d-8577-487d-b5bd-4a420fe5337a',
      authority: 'https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/',
     // redirectUri: 'http://localhost:4200/auth-callback',
     redirectUri: `${origin}`,
     navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: `${origin}`,



    },
    system: {
      popupBridgeTimeout: 95000,
      iframeBridgeTimeout: 95000,
    },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false,
   },
  },
  production: false,
  USER_SERVICE_URL:SUB_HOST+"/users",
  DASHBOARD_SERVICE_URL:SUB_HOST+"/dashboard",
  PURCHASE_ORDER_SERVICE_URL:SUB_HOST+"/po-order",
  REPORTS_SERVICE_HOST:SUB_HOST+"/reports",
  STORE_MAINTAINENCE_SERVICE_URL:SUB_HOST+"/stores",
  DC_MAINTAINENCE_SERVICE_URL:SUB_HOST+"/dc",
  PROVINCE_SERVICE_URL:SUB_HOST,
 // LOG_OUT_URL=""
 NCTM_GET_USER_ACCESS_URL: NCTM_HOST,
 NCTM_UI_HOST : "https://nctm-esign-dev.nane1-lower-gke1.lblw.cloud"
  };


